var cov_1y1yelrrbn = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DataList/BaseItem.tsx",
      hash = "747e5d5eb54411c914828944fcdcc8399c2fbeb2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DataList/BaseItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 43
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "1": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 64
        }
      },
      "2": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 20,
          column: 64
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 11
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 64
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 64
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/DataList/BaseItem.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { listClass } from './styles';
import Meta from './Meta';
import Extra from './Extra';

var BaseItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BaseItem, _PureComponent);

  var _super = _createSuper2(BaseItem);

  function BaseItem() {
    _classCallCheck(this, BaseItem);

    return _super.apply(this, arguments);
  }

  _createClass(BaseItem, [{
    key: "render",
    value: function render() {
      cov_1y1yelrrbn.f[0]++;

      var _ref = (cov_1y1yelrrbn.s[0]++, this.props),
          className = _ref.className,
          extra = _ref.extra,
          props = _objectWithoutProperties(_ref, ["className", "extra"]);

      cov_1y1yelrrbn.s[1]++;

      if (!extra) {
        cov_1y1yelrrbn.b[0][0]++;
        cov_1y1yelrrbn.s[2]++;
        return (
          /*#__PURE__*/
          React.createElement(Meta, Object.assign({}, props, {
            className: className,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 20,
              columnNumber: 24
            }
          }))
        );
      } else {
        cov_1y1yelrrbn.b[0][1]++;
      }

      cov_1y1yelrrbn.s[3]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(listClass('base'), className),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Meta, Object.assign({}, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 9
          }
        })),
        /*#__PURE__*/
        React.createElement(Extra, {
          extra: extra,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 9
          }
        }))
      );
    }
  }]);

  return BaseItem;
}(PureComponent);

export default BaseItem;